export interface IAssetTypeResults {
  assetDimensions: IAssetDimensions[];
  id: number;
  name: string;
  template: {
    id: number;
    name: string;
    isActive: boolean;
  };
}
export interface IAssetDimensions {
  assetDimensions: string;
  assetTypeOption: number;
  createdAt: string;
  desktopDimensions: string;
  id: number;
  mobileDimensions: string;
  tabletDimensions: string;
}

export const AssetTypeNameOther = "other";
